import EnumType from "@/app/shared/EnumType.js";

const values = {
  Development: 0, 
  Production: 1,
  StockPile: 2,
  OpenPit: 3
};

const obj = EnumType.generate(values, "Location.");

obj.getSuffix = function(value) {
  return value === values.Development ? "D" 
    : value === values.Production ? "P" 
      : value === values.StockPile ? "S"              
        : value === values.OpenPit ? "O"
          : "N/A";
}

export default obj;